import { render } from "./CallAverageTimePerDayBarChart.vue?vue&type=template&id=4bbcc80c&ts=true"
import script from "./CallAverageTimePerDayBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallAverageTimePerDayBarChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallAverageTimePerDayBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bbcc80c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bbcc80c', __exports__)) {
    api.reload('4bbcc80c', __exports__)
  }
  
  module.hot.accept("./CallAverageTimePerDayBarChart.vue?vue&type=template&id=4bbcc80c&ts=true", () => {
    api.rerender('4bbcc80c', render)
  })

}


export default __exports__